/** "#rrggbb" 형식 검사 정규식 — validateManifest와 공유. */
export const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

/** "#rrggbb" → 0xrrggbb 숫자. Phaser fillStyle/lineStyle/tint는 숫자 색을 받는다. 형식 오류 시 throw. */
export function hexToNumber(hex: string): number {
  if (!HEX_COLOR_RE.test(hex)) throw new Error(`invalid hex color: ${hex}`);
  return parseInt(hex.slice(1), 16);
}

/** 문자열 hex 팔레트 → 숫자 팔레트 파생 — 앱 부팅 시 1회 계산해 캐시하는 용도. */
export function derivePaletteNumbers<T extends string>(
  palette: Readonly<Record<T, string>>,
): Readonly<Record<T, number>> {
  const out = {} as Record<T, number>;
  for (const key of Object.keys(palette) as T[]) {
    out[key] = hexToNumber(palette[key]);
  }
  return out;
}
